const { getBrowser, requestPermission, getPermissionLevel } = require('./permissions')
const { getCookie, setCookie, deleteCookie } = require('./cookies')
const { loadScript } = require('./scripts')
const { debounce } = require('./timing')
const { docIsReady, isInViewport, elementInView, tabVisibilityChange } = require('./window')
const NcidForwarder = require('./ncid_forwarder')

// eslint-disable-next-line import/newline-after-import
;(() => {
  window.NEXUtils = {
    requestPermission,
    getPermissionLevel,
    getBrowser,
    getCookie,
    setCookie,
    deleteCookie,
    loadScript,
    debounce,
    isInViewport,
    elementInView,
    tabVisibilityChange,
    docIsReady,
    ncidForwarder: new NcidForwarder()
  }
})()
